import { clsx } from 'clsx';

// Utility function to combine class names
export function cn(...inputs) {
  return clsx(inputs);
}

// Format currency
export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
}

// Format date
export function formatDate(date, options = {}) {
  const defaultOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  
  return new Intl.DateTimeFormat('en-US', { ...defaultOptions, ...options }).format(new Date(date));
}

// Debounce function
export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Truncate text
export function truncate(str, length = 100) {
  if (str.length <= length) return str;
  return str.slice(0, length) + '...';
}

// Generate random ID
export function generateId() {
  return Math.random().toString(36).substr(2, 9);
}

export function formatMoney(amount, currency = 'USD') {
  const symbolMap = { USD: '$', CNY: '¥', EUR: '€', GBP: '£', JPY: '¥', HKD: 'HK$' };
  const normalizedCurrency = (currency || 'USD').toUpperCase();
  
  // Handle invalid amount
  if (amount === null || amount === undefined || amount === '') {
    return '-';
  }

  const parsed = typeof amount === 'number' ? amount : Number(amount);
  const formatted = Number.isFinite(parsed) ? parsed.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : String(amount);
  
  const symbol = symbolMap[normalizedCurrency];
  if (symbol) return `${symbol}${formatted}`;
  if (!normalizedCurrency) return formatted;
  return `${normalizedCurrency} ${formatted}`;
}
